// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__1cC1B","iconList":"styles_iconList__25Vg_","item":"styles_item__1fElt"};